<template>
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M17 10.1455V4.53058C16.9865 4.10022 16.7917 3.69246 16.4584 3.39683C16.1251 3.1012 15.6805 2.94184 15.2222 2.95375H2.77778C2.31948 2.94184 1.87487 3.1012 1.54156 3.39683C1.20826 3.69246 1.01348 4.10022 1 4.53058V15.5676C1.01348 15.998 1.20826 16.4057 1.54156 16.7013C1.87487 16.997 2.31948 17.1563 2.77778 17.1444H9.66667"
      stroke="#1E264C"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12.8438 1.14844V4.62668"
      stroke="#1E264C"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M5.4375 1.14844V4.62668"
      stroke="#1E264C"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path d="M1 7.12891H17" stroke="#1E264C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    <path
      d="M15.3333 19.1484C12.9439 19.1484 11 17.3541 11 15.1484C11 12.9428 12.9439 11.1484 15.3333 11.1484C17.7227 11.1484 19.6667 12.9428 19.6667 15.1484C19.6667 17.354 17.7227 19.1484 15.3333 19.1484ZM15.3333 11.5699C13.1957 11.5699 11.4562 13.1753 11.4562 15.1488C11.4562 17.1223 13.1956 18.7277 15.3333 18.7277C17.4709 18.7277 19.2105 17.1223 19.2105 15.1488C19.2105 13.1753 17.4709 11.5699 15.3333 11.5699Z"
      fill="#1E264C"
      stroke="#1E264C"
      stroke-width="0.5"
    />
    <path
      d="M17.2782 17.1471L15 15.2781V12.4805H15.5495V15.0916L17.6667 16.8283L17.2782 17.1471Z"
      fill="#1E264C"
      stroke="#1E264C"
      stroke-width="0.5"
    />
  </svg>
</template>
